/**
 * Persisted sort preference for the Market Place tab.
 *
 * Same deliberate localStorage pattern as benchmarkIndexPref.js: raw string
 * key, try/catch everywhere, and a sane default on any failure. Device-scoped
 * by design - there is no server-side user-preference store in this app.
 */
const KEY = 'banyan_marketplace_sort';

export const MARKETPLACE_SORT_FIELDS = {
  // The firm's own most recent purchase date for the position (from the
  // TRANSACTION ledger), NOT the market's last trade date (that lives on EMMA).
  TRADE_DATE: 'trade_date',
  MARKET_VALUE: 'market_value',
  ACTIVITY: 'activity',
};

const FIELDS = new Set(Object.values(MARKETPLACE_SORT_FIELDS));
const DIRS = new Set(['asc', 'desc']);

export const DEFAULT_MARKETPLACE_SORT = {
  field: MARKETPLACE_SORT_FIELDS.TRADE_DATE,
  dir: 'desc',
};

export function loadMarketplaceSort() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw == null) return { ...DEFAULT_MARKETPLACE_SORT };
    const parsed = JSON.parse(raw);
    if (parsed && FIELDS.has(parsed.field) && DIRS.has(parsed.dir)) {
      return { field: parsed.field, dir: parsed.dir };
    }
    return { ...DEFAULT_MARKETPLACE_SORT };
  } catch (e) {
    return { ...DEFAULT_MARKETPLACE_SORT };
  }
}

export function saveMarketplaceSort(sort) {
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ field: sort.field, dir: sort.dir })
    );
  } catch (e) {
    // Storage full/unavailable - the pick silently lasts for the session only.
  }
}
